import type { MouseEvent } from 'react'

import { Badge } from '@procurify/ui'
import { useHistory } from 'react-router'
import { NavLink, type NavLinkProps } from 'react-router-dom'

import { TabStyled } from './styles/TabStyled'

export interface ITabLinkProps extends NavLinkProps {
  withParams?: () => { [key: string]: string | number }
  count?: number | string
}

export const TabLink = ({
  withParams,
  onClick = () => undefined,
  to,
  count,
  children,
  ...props
}: ITabLinkProps) => {
  const history = useHistory()

  let _onClick

  if (withParams) {
    _onClick = (e: MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation()
      e.preventDefault()

      const paramObj = withParams() || {}

      const paramString = new URLSearchParams(
        paramObj as Record<string, string>
      ).toString()

      history.push(`${to as string}?${paramString}`)

      onClick(e)
    }
  }

  return (
    <TabStyled
      role='tab'
      as={NavLink}
      activeClassName='active'
      to={to}
      onClick={_onClick}
      {...props}
    >
      <>{children}</>
      {Number(count) > 0 && <Badge>{count}</Badge>}
    </TabStyled>
  )
}
